module.exports = __webpack_public_path__ + "r-v3/img/Eraser_on.3538a472.svg";